module.exports = __webpack_public_path__ + "static/img/not_found.b2859dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/404/images/not_found.png
// module id = oFLV
// module chunks = 0